export const FileTypes = {
  DOC: 'doc',
  DOCX: 'docx',
  PDF: 'pdf',
  MP4: 'mp4',
};
